import React from 'react';
import { CARTA_EMAIL, CARTA_TELEFONO, CARTA_WEB } from './legalLabels';

function LegalCartaMarco({
  titulo,
  version,
  fecha,
  children,
  despues,
  cuerpoRef,
  cuerpoClassName = '',
  marcaAgua = false,
}) {
  return (
    <article className="legal-carta">
      <div className="legal-carta-marca">
        <img src="/botomatic_icon.png" alt="Botomatic" className="legal-carta-logo" />
        <span className="legal-carta-wordmark">BOTOMATIC</span>
      </div>
      {marcaAgua ? (
        <img
          src="/botomatic_icon.png"
          alt=""
          className="legal-carta-marca-agua"
          data-testid="legal-carta-marca-agua"
          aria-hidden="true"
        />
      ) : null}
      {fecha ? <p className="legal-carta-fecha">{fecha}</p> : null}
      {titulo ? <h3 className="legal-carta-titulo">{titulo}</h3> : null}
      {version ? <p className="legal-carta-version">{version}</p> : null}
      <div ref={cuerpoRef} className={`legal-carta-cuerpo ${cuerpoClassName}`.trim()}>
        {children}
      </div>
      {despues}
      <footer className="legal-carta-pie">
        <span>{CARTA_TELEFONO}</span>
        <span>{CARTA_EMAIL}</span>
        <span>{CARTA_WEB}</span>
      </footer>
    </article>
  );
}

export default LegalCartaMarco;
